<template>
    <div>

        <div class="row clearfix">
            <div class="col-md-6 column">
                <!-- Adresse : rue et no -->
                <div class="form-group required"  :class="{'has-error': errors.has('adresseRue')}">
                    <label for="adresseRue" class="form-label">{{$t('Bareme.etape1.champs.adresseRue')}}</label>

                    <input type="text" v-model="dossier.adresseRue" name="adresseRue" v-validate="'required'" maxlength="60"
                           class="form-control" id="adresseRue"
                           v-tooltip="{content: getTooltip('Bareme.tooltip.titre.adresseRue','Bareme.tooltip.contenu.adresseRue'), placement: tooltipPlacement }">
                    <span v-if="submitted && errors.has('adresseRue')" class="text-danger">{{ errors.first('adresseRue') }}</span>
                </div>
            </div>
            <div class="col-md-6 column">
                <!-- Adresse : code postal et localité -->
                <div class="form-group required" :class="{'has-error': errors.has('adresseLocalite')}">
                    <label for="adresseLocalite" class="form-label">{{$t('Bareme.etape1.champs.adresseLocalite')}}</label>

                    <input type="text" v-model="dossier.adresseLocalite" name="adresseLocalite" v-validate="'required'" maxlength="60"
                           class="form-control" id="adresseLocalite"
                           v-tooltip="{content: getTooltip('Bareme.tooltip.titre.adresseLocalite','Bareme.tooltip.contenu.adresseLocalite'), placement: tooltipPlacement }">
                    <span v-if="submitted && errors.has('adresseLocalite')" class="text-danger">{{ errors.first('adresseLocalite') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TooltipUtils from '../../../utils/TooltipUtils';

export default {
  name: 'section-adresse',
  props: ['dossier', 'submitted'],
  inject: ['$validator'],
  mixins: [TooltipUtils],
};
</script>

<style scoped>

</style>
